import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-sf-icd-more',
    templateUrl: './sf-icd-more.component.html',
    styleUrls: ['./sf-icd-more.component.scss'],
    standalone: false
})
export class SfIcdMoreComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

    $('.detailchild').removeClass('active');
    $('.detailmain').removeClass('active');
    $('#custom-tabs-four-settings-tab').addClass('active');
    $('#custom-tabs-four-settings-tab').parent().addClass('active');

  }

}
